/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplicationTypes_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null };

export type GetCreditApplicationTypes_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly appVersion: number | null, readonly dsaVersion: string | null, readonly recordType: string | null, readonly majorAccountChanges: ReadonlyArray<_Types.MajorAccountChange | null> | null, readonly status: _Types.CreditApplicationStatus | null, readonly authorizedSigner: GetCreditApplicationTypes_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetCreditApplicationTypes_Query = { readonly __typename: 'Query', readonly creditApplication: GetCreditApplicationTypes_creditApplication_CreditApplication | null };


export type GetCreditApplicationTypesVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetCreditApplicationTypes = GetCreditApplicationTypes_Query;


export const GetCreditApplicationTypesDocument = gql`
    query GetCreditApplicationTypes($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    appVersion
    dsaVersion
    recordType
    majorAccountChanges
    status
    authorizedSigner {
      id
      email
    }
  }
}
    `;

/**
 * __useGetCreditApplicationTypes__
 *
 * To run a query within a React component, call `useGetCreditApplicationTypes` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicationTypes` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicationTypes({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetCreditApplicationTypes(baseOptions: Apollo.QueryHookOptions<GetCreditApplicationTypes, GetCreditApplicationTypesVariables> & ({ variables: GetCreditApplicationTypesVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>(GetCreditApplicationTypesDocument, options);
      }
export function useGetCreditApplicationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>(GetCreditApplicationTypesDocument, options);
        }
export function useGetCreditApplicationTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>(GetCreditApplicationTypesDocument, options);
        }
export type GetCreditApplicationTypesHookResult = ReturnType<typeof useGetCreditApplicationTypes>;
export type GetCreditApplicationTypesLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationTypesLazyQuery>;
export type GetCreditApplicationTypesSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationTypesSuspenseQuery>;
export type GetCreditApplicationTypesQueryResult = Apollo.QueryResult<GetCreditApplicationTypes, GetCreditApplicationTypesVariables>;